import { useEffect, useState } from "react";
import { Phone, Menu, X } from "lucide-react";
import { NAV, PHONE, PHONE_HREF } from "../../data/site";

export const Header = () => {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header data-testid="site-header" className={`fixed inset-x-0 top-0 z-50 transition-colors duration-300 ${scrolled || open ? "bg-black/85 backdrop-blur-xl border-b border-white/10" : "bg-transparent"}`}>
      <div className="mx-auto flex h-20 max-w-7xl items-center justify-between px-5 lg:px-8">
        <a href="#top" data-testid="header-logo-link" className="flex items-center gap-3">
          <img src="/logo.jpg" alt="Pipe-Line UK logo" className="h-14 w-14 rounded-full" />
          <span className="hidden font-display text-xl font-bold uppercase tracking-wide sm:block">Pipe-Line <span className="text-[#1E9BFF]">UK</span></span>
        </a>
        <nav className="hidden items-center gap-8 lg:flex">
          {NAV.map((n) => (
            <a key={n.id} href={`#${n.id}`} data-testid={`nav-link-${n.id}`} className="nav-link text-sm font-medium uppercase tracking-wider text-neutral-300 hover:text-white">{n.label}</a>
          ))}
        </nav>
        <div className="flex items-center gap-3">
          <a href={PHONE_HREF} data-testid="header-phone-link" className="hidden items-center gap-2 font-mono text-sm text-white hover:text-[#1E9BFF] md:flex">
            <Phone className="h-4 w-4 text-[#1E9BFF]" /> {PHONE}
          </a>
          <a href={PHONE_HREF} data-testid="header-phone-icon-mobile" aria-label="Call us" className="grid h-11 w-11 place-items-center border border-[#1E9BFF]/50 text-[#1E9BFF] md:hidden">
            <Phone className="h-5 w-5" />
          </a>
          <a href="#contact" data-testid="header-quote-button" className="btn-primary hidden sm:inline-flex">Get a Quote</a>
          <button data-testid="mobile-menu-toggle" aria-label="Toggle menu" onClick={() => setOpen(!open)} className="grid h-11 w-11 place-items-center border border-white/15 lg:hidden">
            {open ? <X className="h-5 w-5" /> : <Menu className="h-5 w-5" />}
          </button>
        </div>
      </div>
      {open && (
        <nav data-testid="mobile-menu" className="border-t border-white/10 px-5 pb-6 lg:hidden">
          {NAV.map((n) => (
            <a key={n.id} href={`#${n.id}`} onClick={() => setOpen(false)} data-testid={`mobile-nav-link-${n.id}`} className="block border-b border-white/5 py-4 font-display text-2xl font-semibold uppercase">{n.label}</a>
          ))}
          <a href="#contact" onClick={() => setOpen(false)} data-testid="mobile-quote-button" className="btn-primary mt-6 w-full justify-center">Get a Quote</a>
        </nav>
      )}
    </header>
  );
};
